module.exports = __webpack_public_path__ + "static/img/banner03.ed092cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner03.jpg
// module id = WhSF
// module chunks = 1